import React, { useEffect, useState } from "react";
import {
    Card,
    CardHeader,
    Typography,
    AppBar,
    Tabs,
    Tab,
    Box
} from "@material-ui/core";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import Importacao from "./Importacao";
import RelacoesPrevidenciarias from "./RelacoesPrevidenciarias";
import Resultados from "./Resultados";
import Restituicao from "./Restituicao";

import { buscarSeguradoPorCPF, checaExibicaoMensagemImportacaoFontes, confirmarMensagemImportacaoFontes } from "../../Store/Actions/API/seguradosActions";
import { limpaDefinicoesSegurado, setParamsFilterRestituicao, setParamsFilterResultados, setTabIndex } from "../../Store/Actions/Reducer/seguradoActions";
import { setLoadingGeral } from "../../Store/Actions/Reducer/mainActions";
import { formataCpf } from "../../Utils/utils";
import { useStyles } from "./styles";
import ModalConfirmacao from "../../Components/ModalConfirmacao";

export default function Segurado({ match }) {

    const cpfParam = match.params.cpf;

    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();
    const tabIndex = useSelector((state) => state.segurado.tabIndex, shallowEqual);
    const [segurado, setSegurado] = useState(null);
    const [openModalImportacaoFontes, setOpenModalImportacaoFontes] = useState(false);
    const [exibirMensagemImportacaoFontes, setExibirMensagemImportacaoFontes] = useState(false);
    const [loadingConfirmarMensagemImportacao, setLoadingConfirmarMensagemImportacao] = useState(false);

    useEffect(() => {
        setSegurado(null);
        dispatch(limpaDefinicoesSegurado());
        if (cpfParam){
            buscarSegurado();
        } 
    }, [cpfParam]); // eslint-disable-line

    useEffect(() => {
        if (cpfParam){
            checarExibicaoMensagemFontes(tabIndex);
        }
    }, [tabIndex])

    useEffect(() => {
        if(!openModalImportacaoFontes){
            mostrarModalFontesPagadoras(tabIndex)
        }          
    }, [exibirMensagemImportacaoFontes])
    const buscarSegurado = async () => {
        if (!cpfParam) return;

        dispatch(setLoadingGeral(true, "Buscando segurado"));

        let seguradoTemp = await buscarSeguradoPorCPF(cpfParam);

        dispatch(setLoadingGeral(false));

        if (seguradoTemp === null) {
            history.push('/home')
            return;
        }

        setSegurado({ ...seguradoTemp });
    }

    const onChangeTabIndex = (index) => {
        if (index !== tabIndex) {
            dispatch(setParamsFilterResultados({}, true));
            dispatch(setParamsFilterRestituicao({}, true));
            dispatch(setTabIndex(index))
        }
    }
    
    const checarExibicaoMensagemFontes = async (tab) => {
        const exibir = await checaExibicaoMensagemImportacaoFontes(cpfParam);
        if (exibir !== exibirMensagemImportacaoFontes) setExibirMensagemImportacaoFontes(exibir)
        else mostrarModalFontesPagadoras(tab);     
    }

    const handleConfirmarModal = async () => {
        setLoadingConfirmarMensagemImportacao(true);
        await confirmarMensagemImportacaoFontes(cpfParam);
        setExibirMensagemImportacaoFontes(false);
        setLoadingConfirmarMensagemImportacao(false);
        setOpenModalImportacaoFontes(false);
    }

    const handleCancelarModal = () => {
        dispatch(setTabIndex(0));
        setOpenModalImportacaoFontes(false);
    }

    const handleChangeTab = (event, value) => {
        onChangeTabIndex(value)
    }

    const mostrarModalFontesPagadoras = (tab) => {
        if(exibirMensagemImportacaoFontes && tab !== 0)
            setOpenModalImportacaoFontes(true);
    }
    if (segurado) {
        return (
            <>
                <ModalConfirmacao
                    open={openModalImportacaoFontes}
                    onCancela={handleCancelarModal}  
                    isLoading={loadingConfirmarMensagemImportacao}
                    onConfirma={handleConfirmarModal}
                    titulo="Atenção!"
                    confirmarText="Confirmar"
                    texto="Prezado, para uma apuração adequada do crédito recomendamos realizar o cruzamento do relatório CNIS com o relatório de FONTES PAGADORAS. Deseja realmente prosseguir com a apuração SEM a importação do RELATÓRIO DE FONTES PAGADORAS?"   
                />
                <Card className={classes.card}>
                    <CardHeader
                        title={segurado.nome}
                        subheader={formataCpf(segurado.cpf)}
                    />

                    <AppBar position="static" className={classes.appBar}>
                        <Tabs
                            value={tabIndex}
                            onChange={handleChangeTab}
                            aria-label="tabs_segurado"

                            variant="scrollable"
                        >
                            <Tab defaultValue label="Documentos" id={`simple-tab-${0}`} />
                            <Tab label="Relações previdenciárias" id={`simple-tab-${1}`} />
                            <Tab label="Resultados" id={`simple-tab-${2}`} />
                            <Tab label="Restituição" id={`simple-tab-${3}`} />
                        </Tabs>
                    </AppBar>
                    <TabPanel value={tabIndex} index={0}>
                        <Importacao cpf={segurado.cpf} />
                    </TabPanel>
                    <TabPanel value={tabIndex} index={1}>
                        <RelacoesPrevidenciarias cpf={segurado.cpf} />
                    </TabPanel>
                    <TabPanel value={tabIndex} index={2}>
                        <Resultados cpf={segurado.cpf} />
                    </TabPanel>
                    <TabPanel value={tabIndex} index={3}>
                        <Restituicao cpf={segurado.cpf} nome={segurado.nome}/>
                    </TabPanel>
                </Card>
            </>
        );
    } else {
        return null;
    }

    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <Typography
                component="div"
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box px={1} py={2}>
                        {children}
                    </Box>
                )}
            </Typography>
        );
    }
}
